import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { PerfilMenuModel }
from '../../models/configuration/perfil-menu.model';



import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class
GetAllPerfilMenuUseCase
implements UseCase<
void,
PerfilMenuModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        
    ):
    Observable<PerfilMenuModel> {

        return this.repository
            .getAllPerfilMenu(
                
            );
    }
}